import { useState } from 'react'

const langsObj = {
  EN: '',
  ZH_CN: '',
  ZH_HK: '',
}

const defaultData = {
  title: { ...langsObj },
  description: { ...langsObj },
  remarks: '',
}

/**
 * Custom hook to manage survey form state and validation
 * Handles multi-language input and error states
 */
export const useSurveyForm = (initialData = defaultData, requiredKeys = ['title']) => {
  const [data, setData] = useState({ ...initialData })
  const [error, setError] = useState({ ...initialData })

  const handleChange = (fieldName, value) => {
    if (value) {
      setData(d => ({ ...d, [fieldName]: value }))
      setError(p => ({ ...p, [fieldName]: '' }))
    } else {
      setData(d => ({ ...d, [fieldName]: '' }))
      if (requiredKeys.includes(fieldName)) {
        setError(p => ({ ...p, [fieldName]: 'required' }))
      }
    }
  }

  const handleMultiLangChange = (objKey, langKey, value) => {
    if (value) {
      setData(p => ({
        ...p,
        [objKey]: { ...langsObj, ...p[objKey], [langKey]: value },
      }))
      setError(p => ({
        ...p,
        [objKey]: { ...langsObj, ...p[objKey], [langKey]: '' },
      }))
    } else {
      setData(p => ({
        ...p,
        [objKey]: { ...langsObj, ...p[objKey], [langKey]: '' },
      }))
      if (requiredKeys.includes(objKey)) {
        setError(p => ({
          ...p,
          [objKey]: { ...langsObj, ...p[objKey], [langKey]: 'required' },
        }))
      }
    }
  }

  const validate = () => {
    let isValid = true
    const newErrors = { ...error }

    for (const key of requiredKeys) {
      if (typeof data[key] === 'object') {
        const langs = Object.keys(data[key])
        for (const lang of langs) {
          if (!data[key][lang]) {
            newErrors[key] = { ...newErrors[key], [lang]: 'required' }
            isValid = false
          }
        }
      } else if (!data[key]) {
        newErrors[key] = 'required'
        isValid = false
      }
    }

    setError(newErrors)
    return isValid
  }

  const reset = () => {
    setData({ ...initialData })
    setError({ ...initialData })
  }

  return {
    data,
    error,
    handleChange,
    handleMultiLangChange,
    validate,
    reset,
    setData,
    setError,
  }
}
